import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  lucideRocket,
  lucideLayoutDashboard,
  lucideCode,
  lucideGlobe,
} from '@ng-icons/lucide';

export type AnalysisSource = 'campaign' | 'hub' | 'plugin' | 'api' | string;

interface SourceMeta {
  label: string;
  icon: string;
}

const SOURCE_METADATA: Record<string, SourceMeta> = {
  campaign: {
    label: 'Kampagne',
    icon: 'lucideRocket',
  },
  hub: {
    label: 'Hub',
    icon: 'lucideLayoutDashboard',
  },
  plugin: {
    label: 'Plugin',
    icon: 'lucideGlobe',
  },
  api: {
    label: 'API',
    icon: 'lucideCode',
  },
};

const DEFAULT_META: SourceMeta = {
  label: 'Unbekannt',
  icon: 'lucideCode',
};

@Component({
  selector: 'app-analysis-source-badge',
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  providers: [
    provideIcons({
      lucideRocket,
      lucideLayoutDashboard,
      lucideCode,
      lucideGlobe,
    }),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Guide v1.1, Tables: the source is metadata, so a quiet icon and the word, no coloured chip.
  template: `
    <span class="inline-flex items-center gap-1.5 whitespace-nowrap text-dense text-foreground">
      <ng-icon [name]="meta().icon" class="size-3.5 shrink-0 text-muted-foreground"></ng-icon>
      {{ meta().label }}
    </span>
  `,
})
export class AnalysisSourceBadge {
  source = input<AnalysisSource | null | undefined>(null);

  readonly meta = computed<SourceMeta>(() => {
    const src = this.source();
    if (!src) return DEFAULT_META;
    return SOURCE_METADATA[src] ?? { ...DEFAULT_META, label: src };
  });
}
